// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cg-pagination {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding: 10px 0 2px;
  margin-top: 8px;
}

.cg-page-btn {
  min-width: 28px;
  height: 28px;
  padding: 0 6px;
  border-radius: 50%;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.cg-page-btn:hover:not(:disabled) {
  background: #213a22; /* brand green */
  border-color: #213a22;
  color: #fff;
}

.cg-page-btn.active {
  background: #b9922f; /* brand gold */
  border-color: #b9922f;
  color: #fff;
  font-weight: 700;
}

.cg-page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.cg-page-arrow {
  font-weight: 700;
}

.cg-page-ellipsis {
  color: #94a3b8;
  padding: 0 2px;
  -webkit-user-select: none;
          user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pagination.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB,EAAE,gBAAgB;EACrC,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB,EAAE,eAAe;EACpC,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB","sourcesContent":[".cg-pagination {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 0 2px;\n  margin-top: 8px;\n}\n\n.cg-page-btn {\n  min-width: 28px;\n  height: 28px;\n  padding: 0 6px;\n  border-radius: 50%;\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #334155;\n  font-size: 12px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n}\n\n.cg-page-btn:hover:not(:disabled) {\n  background: #213a22; /* brand green */\n  border-color: #213a22;\n  color: #fff;\n}\n\n.cg-page-btn.active {\n  background: #b9922f; /* brand gold */\n  border-color: #b9922f;\n  color: #fff;\n  font-weight: 700;\n}\n\n.cg-page-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.cg-page-arrow {\n  font-weight: 700;\n}\n\n.cg-page-ellipsis {\n  color: #94a3b8;\n  padding: 0 2px;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
